import { useEffect, useRef } from 'react'
import { analytics, type AnalyticsOnboardingVariant, type AnalyticsOnboardingStep } from '../../../lib/analytics'
import { useAuthStore } from '../../../store/authStore'
import { useOnboardingStore } from '../../../store/onboardingStore'

// Observe the displayed screen, not button clicks or individual quiz questions.
export function useOnboardingAnalytics(variant: AnalyticsOnboardingVariant, step: AnalyticsOnboardingStep | null) {
  const started = useRef(false)
  const displayed = useRef<string | null>(null)
  useEffect(() => {
    if (step === null) return
    // Clearing a submitted quiz draft can remount the default scenario before
    // navigation finishes. It is not a new onboarding for this account.
    const { userId } = useAuthStore.getState()
    const { onboarded, onboardedForUserId } = useOnboardingStore.getState()
    if (userId && onboarded && onboardedForUserId === userId) return
    if (step === 1 && !started.current) started.current = analytics.track('onboardingStarted', { variant })
    const key = `${variant}:${step}`
    if (displayed.current !== key && analytics.track('onboardingStepViewed', { variant, step })) displayed.current = key
  }, [variant, step])
}
